var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.port._id)?_c('div',{staticClass:"port",style:({ left: _vm.port.left + 'px', top: _vm.port.top + 'px', opacity: _vm.port.linkedBridge ? 0 : 1 }),attrs:{"id":_vm.port.code,"x":_vm.port.left + 37.5,"y":_vm.port.top + 37.5}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }